<template>
  <div ref="tableauWrapper" />
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { onMounted, ref } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

declare global {
  interface Window {
    tableau: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Viz: any
    }
  }
}

const props = defineProps<{
  insight?: {
    project: string
    view?: string
  }
}>()

const logger = useLogger()
const { openErrorToast } = useTheToast()
const tableauWrapper = ref(null)
const $httpFetch = useHttpFetch()

const route = useRoute()

onMounted(async () => {
  try {
    const { url } = await $httpFetch(
      '/api/seller-experience/insights/embedded',
      {
        query: {
          view: (route.query.view as string) || (props.insight?.view ?? ''),
          project: props.insight?.project || '',
        },
      },
    )

    // eslint-disable-next-line no-new
    new window.tableau.Viz(tableauWrapper.value, url, {
      width: '100%',
      height: '80vh',
      hideTabs: true,
      hideToolbar: true,
    })
  } catch (error) {
    openErrorToast()
    logger.error(
      `There was a problem with the ${props.insight?.project} tableau dashboard`,
      { owners: ['bot-squad-seller-experience-front'] },
    )
  }
})
</script>
